import React from "react";
import { ProCard } from "@ant-design/pro-components";
import { Typography } from "antd";
import { baseURL, token } from "../../config/config";
import { createFromIconfontCN } from "@ant-design/icons";
import styles from "./index.module.css";

const { Link } = Typography;
const IconFont = createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/c/font_4247980_kj93hx4fvkj.js",
});

// ChangeLog 组件用于展示变更日志
export default function ChangeLog({ series_id }) {
  return (
    <ProCard
      title={<div className={styles.title}>{`${series_id}_CHANGELOG`}</div>} // 标题
      bordered // 边框
      headerBordered // 头部边框
      collapsed={false} // 默认展开
      extra={ // 额外内容，包含下载链接
        <Link
          href={`${baseURL}/api/plm/product/series/${series_id}/release-notes.md?mode=inline&access_token=${token}&firmware_category=firmware&lang=en`}
        >
          {/* 使用 IconFont 组件展示下载图标 */}
          <IconFont
            type="icon-download"
            style={{ fontSize: 28, padding: "2.564vw", color: "#000" }}
          />
        </Link>
      }
    ></ProCard>
  );
}
